
import React from 'react';
import { Mail, MapPin, Phone, MessageCircle, Send } from 'lucide-react';
import { CONTACT_EMAIL, WHATSAPP_NUMBER, LOCATION } from '../constants';

const Contact: React.FC = () => {
  return (
    <div className="bg-white min-h-screen">
      <section className="bg-slate-50 py-24 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6">Contact EduZone</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Have suggestions, feedback, or need help with our resources? Reach out to us. We're always here to support Pakistani students.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-10">Get in Touch</h2>
            <div className="space-y-12">
              <div className="flex gap-6">
                <div className="bg-blue-50 p-4 rounded-2xl shrink-0"><MapPin className="text-blue-600 h-8 w-8" /></div>
                <div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">Our Office</h4>
                  <p className="text-slate-600 leading-relaxed text-lg">{LOCATION}</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="bg-blue-50 p-4 rounded-2xl shrink-0"><Mail className="text-blue-600 h-8 w-8" /></div>
                <div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">Email Address</h4>
                  <p className="text-slate-600 leading-relaxed text-lg">{CONTACT_EMAIL}</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="bg-blue-50 p-4 rounded-2xl shrink-0"><MessageCircle className="text-blue-600 h-8 w-8" /></div>
                <div>
                  <h4 className="text-xl font-bold text-slate-900 mb-2">WhatsApp Support</h4>
                  <p className="text-slate-600 leading-relaxed text-lg">{WHATSAPP_NUMBER}</p>
                </div>
              </div>
            </div>
            
            <div className="mt-16 bg-slate-50 p-10 rounded-3xl">
              <h4 className="text-xl font-bold mb-4">Hours of Operation</h4>
              <p className="text-slate-600">Monday - Friday: 9:00 AM - 5:00 PM</p>
              <p className="text-slate-600">Saturday: 10:00 AM - 2:00 PM</p>
              <p className="text-slate-600 font-bold mt-4 text-blue-600 italic">"Our digital portal is open 24/7 for all students."</p>
            </div>
          </div>

          <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-2xl">
            <h2 className="text-3xl font-bold text-slate-900 mb-8">Send a Message</h2>
            <form className="space-y-6" onSubmit={(e) => {e.preventDefault(); alert('Message sent successfully!');}}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-wide">Your Name</label>
                  <input type="text" className="w-full bg-slate-50 border-0 rounded-xl px-5 py-4 focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Ali Raza" required />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-wide">Email Address</label>
                  <input type="email" className="w-full bg-slate-50 border-0 rounded-xl px-5 py-4 focus:ring-2 focus:ring-blue-500 outline-none" placeholder="ali@example.pk" required />
                </div>
              </div>
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-wide">Subject</label>
                <input type="text" className="w-full bg-slate-50 border-0 rounded-xl px-5 py-4 focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Note Request / Suggestion" />
              </div>
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-2 uppercase tracking-wide">Message</label>
                <textarea className="w-full bg-slate-50 border-0 rounded-xl px-5 py-4 focus:ring-2 focus:ring-blue-500 outline-none h-40" placeholder="Tell us how we can help you..." required></textarea>
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white py-5 rounded-xl font-bold text-lg hover:bg-blue-700 transition shadow-xl flex items-center justify-center gap-2">
                <Send size={20} />
                Submit Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
